/* ZINKE — „Zuletzt angesehen“ frisch halten (26.09.2026, Theme 8.1)

   Problem (Pascal, Screenshot 26.09.): Die Reihe zeigte kaputte Bilder, den
   Dateinamen als Text, alte Titel und dasselbe Produkt doppelt.

   Ursache: assets/zinke-32.js merkt sich beim Besuch Titel, Bild-URL, Preis und
   Handle im Browser (localStorage „zinke_gesehen“) und zeigt diese Werte später
   unverändert an. Wird danach ein Bild ersetzt, ein Titel geändert oder ein
   Handle umbenannt, bleibt der alte Stand stehen: Bild 404, alter Titel, und
   bei neuem Handle ein zweiter Eintrag für dasselbe Produkt.

   Lösung: Nach dem Zeichnen holt dieses Skript für jeden Eintrag die aktuellen
   Daten aus /products/<handle>.js (folgt Weiterleitungen alter Handles) und
   - ersetzt Titel, Link, Bild, Preis und Produkttyp durch den aktuellen Stand,
   - entfernt Einträge, die es nicht mehr gibt (404),
   - entfernt Dubletten über die Produkt-ID,
   - zeigt höchstens 6 Einträge (am Laptop genau eine Reihe),
   - schreibt den bereinigten Stand zurück in den Speicher.
   Ein Bild, das trotzdem nicht lädt, wird ausgeblendet statt als Dateiname
   angezeigt. Geladen aus snippets/zinke-katleiste.liquid, NACH zinke-32.js. */
(function () {
  'use strict';
  var SPEICHER = 'zinke_gesehen';
  var MAX = 6;

  function lesen() {
    try { var w = JSON.parse(localStorage.getItem(SPEICHER) || '[]'); return Array.isArray(w) ? w : []; }
    catch (e) { return []; }
  }
  function schreiben(liste) {
    try { localStorage.setItem(SPEICHER, JSON.stringify(liste.slice(0, 10))); } catch (e) {}
  }
  function wurzel() {
    try { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; } catch (e) { return '/'; }
  }
  function waehrung() {
    try { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'; } catch (e) { return 'EUR'; }
  }
  function preis(cent) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: waehrung() }).format(cent / 100);
    } catch (e) { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function bildUrl(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=540';
  }

  function holen(h) {
    return fetch(wurzel() + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json().then(function (d) { d._url = r.url; return d; }); });
  }

  function start() {
    var sektionen = document.querySelectorAll('[data-z-zuletzt]');
    if (!sektionen.length) return;
    var eintraege = lesen().filter(function (x) { return x && x.h; });
    if (!eintraege.length) return;

    Promise.all(eintraege.map(function (x) {
      return holen(x.h).then(function (d) { return { alt: x, neu: d }; }, function () { return { alt: x, neu: null }; });
    })).then(function (ergebnisse) {
      var gesehen = {};
      var sauber = [];
      ergebnisse.forEach(function (r) {
        if (!r.neu || !r.neu.id || gesehen[r.neu.id]) return;
        gesehen[r.neu.id] = true;
        var d = r.neu;
        var bild = d.featured_image || (d.images && d.images[0]) || '';
        sauber.push({
          h: d.handle,
          id: d.id,
          t: String(d.title || '').split(' – ')[0],
          u: wurzel() + 'products/' + d.handle,
          i: bildUrl(bild),
          a: d.title,
          p: preis(d.price),
          y: d.type || r.alt.y || ''
        });
      });
      schreiben(sauber);
      zeichnen(sektionen, sauber);
    }).catch(function () {});
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function zeichnen(sektionen, liste) {
    Array.prototype.forEach.call(sektionen, function (sek) {
      var aktuell = sek.getAttribute('data-aktuell') || '';
      var min = parseInt(sek.getAttribute('data-min'), 10) || 1;
      var spur = sek.querySelector('[data-z-zuletzt-spur]');
      if (!spur) return;
      var zeigen = liste.filter(function (x) { return x.h !== aktuell; }).slice(0, MAX);
      if (zeigen.length < min) { sek.hidden = true; return; }
      spur.innerHTML = zeigen.map(function (x) {
        var bild = x.i ? '<img src="' + esc(x.i) + '" alt="' + esc(x.a) + '" loading="lazy" width="540" height="540" onerror="this.remove()">' : '';
        return '<article class="product-card" role="listitem">' +
          '<a class="product-card-media" href="' + esc(x.u) + '" tabindex="-1" aria-hidden="true">' + bild + '</a>' +
          '<div class="product-card-caption"><h3 class="product-card-title"><a href="' + esc(x.u) + '">' + esc(x.t) + '</a></h3>' +
          '<div class="product-card-price">' + esc(x.p) + '</div>' +
          (x.y ? '<p class="product-card-subtitle">' + esc(x.y) + '</p>' : '') + '</div></article>';
      }).join('');
      sek.hidden = false;
    });
  }

  /* Sofort: kaputte Bilder der schon gezeichneten Karten nicht als Dateiname zeigen */
  function sofortHeilen() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-z-zuletzt-spur] img'), function (img) {
      if (img.complete && img.naturalWidth === 0) img.remove();
      else img.addEventListener('error', function () { img.remove(); });
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-z-zuletzt-spur]'), function (spur) {
      var karten = spur.children;
      for (var i = karten.length - 1; i >= MAX; i--) karten[i].remove();
    });
  }

  function los() {
    try { sofortHeilen(); } catch (e) {}
    try { start(); } catch (e) { if (window.console) console.warn('zinke-zuletzt', e); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
})();
